export const INPUT_TYPES = {
  TEXT: 'text',
  MEDIA: 'media',
  LOCATION: 'location',
  EMAIL: 'email',
  PASSWORD: 'password',
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
  DATE: 'date',
  PHONE: 'phone',
  NUMBER: 'number',
  BARCODE: 'barcode',
  SIGNATURE: 'signature',
};

export const MESSAGE_ACTIONS = [
  {
    title: 'Text',
    icon: 'fas fa-font fa-fw',
    type: INPUT_TYPES.TEXT,
  },
  {
    title: 'Media',
    icon: 'fas fa-film fa-fw',
    type: INPUT_TYPES.MEDIA,
  },
  {
    title: 'Location',
    icon: 'fas fa-map-marked-alt fa-fw',
    type: INPUT_TYPES.LOCATION,
  },
  {
    title: 'Email',
    icon: 'fas fa-envelope-square fa-fw',
    type: INPUT_TYPES.EMAIL,
  },
  {
    title: 'Password',
    icon: 'fas fa-lock fa-fw',
    type: INPUT_TYPES.PASSWORD,
  },
  {
    title: 'Radio',
    icon: 'fas fa-list fa-fw',
    type: INPUT_TYPES.RADIO,
  },
  {
    title: 'Checkbox',
    icon: 'fas fa-tasks fa-fw',
    type: INPUT_TYPES.CHECKBOX,
  },
  {
    title: 'Date',
    icon: 'fas fa-calendar-day fa-fw',
    type: INPUT_TYPES.DATE,
  },
  {
    title: 'Phone',
    icon: 'fas fa-phone fa-fw',
    type: INPUT_TYPES.PHONE,
  },
  {
    title: 'Number',
    icon: 'fas fa-list-ol fa-fw',
    type: INPUT_TYPES.NUMBER,
  },
  {
    title: 'Barcode',
    icon: 'fas fa-barcode',
    type: INPUT_TYPES.BARCODE,
  },
  {
    title: 'Signature',
    icon: 'fas fa-signature',
    type: INPUT_TYPES.SIGNATURE,
  },
];

export const MediaTypes = [
  {
    text: '-----',
    value: '',
  },
  {
    text: 'Image',
    value: 'image',
  },
  {
    text: 'Audio',
    value: 'audio',
  },
  {
    text: 'Video',
    value: 'video',
  },
  {
    text: 'Pdf',
    value: 'application/pdf',
  },
];

export const DateTypes = [
  {
    text: '-----',
    value: '',
  },
  {
    text: 'AAAA-MM-DD',
    value: 'AAAA-MM-DD',
  },
  {
    text: 'YYYY-mm-dd',
    value: 'YYYY-mm-dd',
  },
  {
    text: 'dd/mm/YYYY',
    value: 'dd/mm/YYYY',
  },
  {
    text: 'mm/dd/YYYY',
    value: 'mm/dd/YYYY',
  },
];

export const PasswordTypes = [
  {
    text: '-----',
    value: '',
  },
  {
    text: 'Number',
    value: 'number',
  },
  {
    text: 'Text',
    value: 'text',
  },
];

export const PasswordSize = [
  {
    text: '-----',
    value: '',
  },
  {
    text: '4',
    value: 4,
  },
  {
    text: '16',
    value: 16,
  },
];

export const LocationSubtypes = [
  {
    text: '-----',
    value: '',
  },
  {
    text: 'Current',
    value: 'current',
  },
  {
    text: 'Map',
    value: 'map',
  },
  {
    text: 'Live Location',
    value: 'live_location',
  },
];

export const LocationFormat = [
  {
    text: '-----',
    value: '',
  },
  {
    text: 'Degrees',
    value: 'degrees',
  },
  {
    text: 'Minutes',
    value: 'minutes',
  },
  {
    text: 'Seconds',
    value: 'seconds',
  },
];

export const PICKER_OPTIONS = [
  {
    text: '-----',
    value: '',
  },
  {
    text: 'Camera',
    value: 'camera',
  },
  {
    text: 'Gallery',
    value: 'gallery',
  },
  {
    text: 'All',
    value: 'all',
  },
];

export const CAMERA_OPTIONS = [
  {
    text: '-----',
    value: '',
  },
  {
    text: 'Front',
    value: 'front',
  },
  {
    text: 'Back',
    value: 'back',
  },
];
